import { Container, Grid, Typography, Box, Stack, Link } from '@mui/material';
import { MOM_CATALOG_PRODUCTS } from '../../data/products';
import { CatalogCard } from '../molecules/CatalogCard';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const CatalogTemplate = () => (
  <Box 
    component="main"
    className="catalog-template-root"
    sx={{ 
      py: 0, 
      bgcolor: 'background.default',
      backgroundImage: 'radial-gradient(#FFB7C5 0.5px, transparent 0.5px)', // Efecto papel deco
      backgroundSize: '20px 20px',
    }}
  >
    {/* Carátula - Ahora visible en Web e Impresión */}
    <Box 
      className="print-only-cover"
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: '80vh', md: '100vh' },
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        bgcolor: '#FFF5F7',
        backgroundImage: `
          radial-gradient(circle at 50% 50%, #FFB7C5 0%, transparent 80%),
          radial-gradient(#E08EA0 0.5px, transparent 0.5px)
        `,
        backgroundSize: '100% 100%, 30px 30px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        py: { xs: 10, md: '20mm' },
        '@media print': {
          height: '297mm',
          width: '210mm',
          breakAfter: 'page',
          pt: '10mm',
          py: 0
        }
      }}
    >
      {/* Destellos decorativos */}
      <AutoAwesomeIcon sx={{ position: 'absolute', top: '15%', left: '10%', color: 'primary.main', opacity: 0.3, fontSize: 60, transform: 'rotate(-15deg)' }} />
      <AutoAwesomeIcon sx={{ position: 'absolute', top: '35%', right: '12%', color: 'primary.main', opacity: 0.3, fontSize: 40, transform: 'rotate(20deg)' }} />
      <AutoAwesomeIcon sx={{ position: 'absolute', bottom: '25%', left: '5%', color: 'primary.main', opacity: 0.3, fontSize: 80, transform: 'rotate(10deg)' }} />
      <FavoriteIcon sx={{ position: 'absolute', top: '20%', right: '18%', fontSize: '120px', color: 'secondary.main', opacity: 0.15, transform: 'rotate(25deg)' }} />
      <FavoriteIcon sx={{ position: 'absolute', bottom: '15%', left: '15%', fontSize: '100px', color: 'secondary.main', opacity: 0.15, transform: 'rotate(-20deg)' }} />

      <Box 
        component="img" 
        src="/logo.png" 
        alt="Logo 3 Corazones"
        sx={{ 
          width: '80mm', 
          mb: 4, 
          zIndex: 10,
          filter: 'drop-shadow(0px 10px 20px rgba(0,0,0,0.1))',
          mixBlendMode: 'multiply'
        }} 
      />
      
      <Typography 
        component="h1"
        sx={{ 
          fontSize: {
            xs: '3.5rem',
            md: '6.5rem'
          }, 
          '@media print': {
            fontSize: '55pt !important',
            lineHeight: 1.2
          },
          color: 'secondary.dark',
          fontWeight: 900,
          fontFamily: 'Playfair Display',
          letterSpacing: 12,
          lineHeight: 1,
          mt: 1,
          zIndex: 10,
          textShadow: '2px 2px 0px rgba(255,255,255,0.8)'
        }}
      >
        CATÁLOGO
      </Typography>
      
      <Typography 
        component="span"
        sx={{ 
          fontSize: {
            xs: '1.4rem',
            md: '2.2rem'
          },
          '@media print': {
            fontSize: '22pt !important',
            mt: 2
          },
          color: 'primary.main',
          fontWeight: 800,
          letterSpacing: 15,
          mt: 0.5,
          zIndex: 10
        }}
      >
        DÍA DE LAS
      </Typography>

      <Typography 
        component="span"
        sx={{ 
          fontSize: {
            xs: '6rem',
            md: '11rem'
          }, 
          '@media print': {
            fontSize: '95pt !important',
            mt: 1,
            mb: 6
          },
          color: 'secondary.dark',
          fontFamily: 'Playfair Display',
          fontStyle: 'italic',
          lineHeight: 0.8,
          mb: 6,
          zIndex: 10,
          filter: 'drop-shadow(5px 5px 0px rgba(255,183,197,0.3))'
        }}
      >
        Madres
      </Typography>

      {/* Círculos de Productos (Estilo Flabebé) con decoraciones extras */}
      <Stack 
        direction="row" 
        spacing={{ xs: -4, sm: -6, md: -8 }} 
        sx={{ 
          mt: 4,
          mb: 4,
          zIndex: 10, 
          alignItems: 'center',
          justifyContent: 'center',
          '@media print': {
            spacing: '-8 !important',
            flexDirection: 'row !important'
          }
        }}
      >
        <Box sx={{ 
          width: { xs: '140px', sm: '200px', md: '70mm' }, 
          height: { xs: '140px', sm: '200px', md: '70mm' }, 
          borderRadius: '50%', 
          border: '8px solid white', 
          overflow: 'hidden',
          transform: 'rotate(-12deg) translateY(20px)',
          boxShadow: '0px 15px 40px rgba(0,0,0,0.1)',
          zIndex: 1,
          '@media print': {
            width: '70mm !important',
            height: '70mm !important'
          }
        }}>
          <Box component="img" src={MOM_CATALOG_PRODUCTS[3].imageUrl} alt="Arreglo floral 1" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </Box>
        <Box sx={{ 
          width: { xs: '190px', sm: '280px', md: '95mm' }, 
          height: { xs: '190px', sm: '280px', md: '95mm' }, 
          borderRadius: '50%', 
          border: '10px solid white', 
          overflow: 'hidden',
          boxShadow: '0px 20px 50px rgba(0,0,0,0.15)',
          zIndex: 3,
          '@media print': {
            width: '95mm !important',
            height: '95mm !important'
          }
        }}>
          <Box component="img" src={MOM_CATALOG_PRODUCTS[0].imageUrl} alt="Arreglo floral principal" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </Box>
        <Box sx={{ 
          width: { xs: '140px', sm: '200px', md: '70mm' }, 
          height: { xs: '140px', sm: '200px', md: '70mm' }, 
          borderRadius: '50%', 
          border: '8px solid white', 
          overflow: 'hidden',
          transform: 'rotate(12deg) translateY(20px)',
          boxShadow: '0px 15px 40px rgba(0,0,0,0.1)',
          zIndex: 1,
          '@media print': {
            width: '70mm !important',
            height: '70mm !important'
          }
        }}>
          <Box component="img" src={MOM_CATALOG_PRODUCTS[1].imageUrl} alt="Arreglo floral 2" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </Box>
      </Stack>

      {/* <Typography
        sx={{
          mt: 6,
          zIndex: 10,
          fontFamily: 'Dancing Script',
          fontSize: '2.5rem',
          color: 'secondary.dark',
          opacity: 0.8
        }}
      >
        "Donde la vida comienza y el amor nunca termina"
      </Typography> */}
      
      {/* Decoración en esquinas */}
      <Box sx={{ position: 'absolute', top: -150, left: -150, width: 450, height: 450, borderRadius: '50%', bgcolor: 'secondary.light', opacity: 0.3, zIndex: 0 }} />
      <Box sx={{ position: 'absolute', bottom: -200, right: -200, width: 550, height: 550, borderRadius: '50%', bgcolor: 'secondary.light', opacity: 0.3, zIndex: 0 }} />
      
      <Typography 
        variant="caption" 
        sx={{ 
          position: 'absolute', 
          bottom: '10mm', 
          color: 'secondary.dark', 
          fontWeight: 800, 
          letterSpacing: 4,
          fontSize: '1.2rem !important',
        }}
      >
        3 CORAZONES • HECHO CON AMOR • 2026
      </Typography>
    </Box>

    <Container 
      maxWidth="lg" 
      sx={{ 
        px: { xs: 2, md: 4 },
        mt: 5,
        '@media print': {
          maxWidth: '100% !important',
          padding: '0 15mm !important', // Aseguramos 15mm a los lados y 0 arriba/abajo
          marginTop: '16px !important'
        }
      }}
    >
      {/* Banner de Preventa - Llamativo y Atractivo */}
      <Box 
        sx={{ 
          mb: 6, 
          p: { xs: 3, md: 4 }, 
          borderRadius: 4, 
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #FFE5E9 0%, #FFB7C5 100%)',
          border: '2px solid',
          borderColor: 'secondary.light',
          boxShadow: '0px 20px 40px rgba(224, 142, 160, 0.25)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          '@media print': {
            mb: 4,
            p: 3,
            breakInside: 'avoid',
            boxShadow: 'none',
            border: '2px solid #FFB7C5'
          }
        }}
      >
        {/* Elementos decorativos flotantes */}
        <FavoriteIcon sx={{ position: 'absolute', top: -10, left: -10, fontSize: 60, color: 'secondary.main', opacity: 0.2, transform: 'rotate(-15deg)' }} />
        <AutoAwesomeIcon sx={{ position: 'absolute', bottom: -5, right: 10, fontSize: 40, color: 'primary.main', opacity: 0.3 }} />
        
        <Typography 
          variant="overline" 
          sx={{ 
            color: 'secondary.dark', 
            fontWeight: 900, 
            letterSpacing: 4,
            fontSize: '1rem',
            '@media print': {
              fontSize: '10pt !important',
              margin: '0 !important',
              lineHeight: 1
            }
          }}
        >
          PROMOCIÓN EXCLUSIVA
        </Typography>

        <Typography 
          variant="h3" 
          sx={{ 
            color: 'secondary.dark', 
            fontWeight: 900,
            fontFamily: 'Playfair Display',
            fontSize: { xs: '2rem', md: '3.5rem' },
            textShadow: '1px 1px 0px white',
            '@media print': {
              fontSize: '24pt !important',
              margin: '2mm 0 !important'
            }
          }}
        >
          Preventa Día de la Madre
        </Typography>

        <Box 
          sx={{ 
            bgcolor: 'secondary.main', 
            color: 'white', 
            px: 3, 
            py: 1, 
            borderRadius: 100,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            boxShadow: '0px 5px 15px rgba(224, 142, 160, 0.4)',
            mt: 1,
            '@media print': {
              mt: 0,
              px: 2,
              py: 0.5,
              boxShadow: 'none'
            }
          }}
        >
          <AutoAwesomeIcon fontSize="small" />
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 900, 
              letterSpacing: 1,
              '@media print': {
                fontSize: '14pt !important',
                margin: '0 !important'
              }
            }}
          >
            10% MENOS EN TODO EL CATÁLOGO
          </Typography>
          <AutoAwesomeIcon fontSize="small" />
        </Box>

        <Typography 
          variant="body1" 
          sx={{ 
            mt: 2, 
            color: 'secondary.dark', 
            fontWeight: 600,
            maxWidth: '600px',
            lineHeight: 1.4,
            '@media print': {
              mt: 1,
              fontSize: '10pt !important',
              maxWidth: '100% !important'
            }
          }}
        >
          ¡No esperes al último momento! Asegura el regalo perfecto para mamá con un precio especial reservando hoy mismo.
        </Typography>
      </Box>

      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          gap: 0,
          py: 0,
          '@media print': {
            mt: '-10mm !important' // Reducido a la mitad
          }
        }}
      >
        {MOM_CATALOG_PRODUCTS.map((product, index) => (
          <Box 
            key={product.id}
            component="section"
            sx={{
              mb: { xs: 2, md: '-20px' },
              p: 0,
              '@media print': {
                breakInside: 'avoid',
                mb: '-20mm !important', // Reducido a la mitad (-20mm)
                p: '0 !important',
                position: 'relative',
                zIndex: index
              }
            }}
          >
            <CatalogCard product={product} index={index} />
          </Box>
        ))}
      </Box>

      <Box 
        component="footer"
        className="footer-section"
        sx={{ 
          mt: { xs: 8, md: 12 }, 
          mb: 3,
          textAlign: 'center', 
          p: { xs: 4, md: 6 }, 
          borderRadius: 2, 
          bgcolor: 'white', 
          border: '2px dashed', 
          borderColor: 'secondary.main',
          boxShadow: '0px 10px 30px rgba(224, 142, 160, 0.1)',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -20,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 100,
            height: 40,
            bgcolor: 'secondary.light',
            opacity: 0.5,
            zIndex: -1,
            borderRadius: 1
          }
        }}
      >
        <Typography variant="h3" component="h2" color="primary.main" gutterBottom sx={{ fontSize: { xs: '2.5rem', md: '4rem' } }}>
          ¿Hacemos tu pedido realidad?
        </Typography>
        <Typography variant="body1" color="text.primary" sx={{ mb: 4, fontWeight: 700, fontSize: '1.2rem' }}>
          Somos 3 corazones: Detalles que nacen del alma para celebrar momentos inolvidables.
        </Typography>

        <Stack spacing={1} sx={{ mb: 4, alignItems: 'center' }}>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ✨ Todos nuestros ramos son 100% hechos a mano.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            📦 Enviamos a todo el Perú.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            📍 Separa tu pedido con el 50% de anticipo.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.dark' }}>
            📞 Consultas: <Link href="https://wa.me/51900090323?text=Hola%203%20Corazones,%20quisiera%20hacer%20un%20pedido" target="_blank" rel="noopener" sx={{ color: 'primary.dark' }}>+51 900090323</Link>
          </Typography>
        </Stack>

        <Typography variant="caption" sx={{ display: 'block', mt: 4, opacity: 0.6, letterSpacing: 2, fontWeight: 700 }}>
          © 2026 - 3 CORAZONES - HECHO CON AMOR
        </Typography>
      </Box>
    </Container>
  </Box>
);
